import axios from 'axios';
import { homePageBuilder } from '@/homePageBuilder';
import baseAssetsModule from '@/baseAssets/module';

export async function HomepageSegmentLazyLoader() {
    const gdprCookie = baseAssetsModule.getCookie('gdprCookie') || baseAssetsModule.getCookie('__Host-gdprCookie');
    const $homepageSegments = $('.homepage-segments');

    if (!gdprCookie || !$homepageSegments.length) return;

    loadContainersOnScroll($homepageSegments);
}

const loadContainersOnScroll = ($homepageSegments) => {
    const $spinnerTemplate = $('.js_homepage-spinner-template').html();
    const total = parseInt($homepageSegments.data('total'));
    let page = parseInt($homepageSegments.data('page'));
    let loading = false;

    const loadNextSegment = async () => {
        if (loading || page > total) return;

        loading = true;
        page++;

        // 'recently-viewed' and 'usp' containers are excluded from main container group
        // 'recently-viewed' to bypass caching logic
        // 'usp' is always rendered last due to its specific CSS styling
        const url = page <= total
            ? `/segment/lazy?page=${page}`
            : '/segment/lazy/recently-viewed-usp';

        $homepageSegments.append($spinnerTemplate.trim());

        try {
            const response = await axios.get(url);
            $('.js_homepage-spinner').remove();

            if (!response?.data?.template) return;

            $('.js_slider-unique-line').removeClass('js_slider-unique-line');
            $('.js_slider-from-ajax').removeClass('js_slider-from-ajax');

            $homepageSegments.append($(response.data.template.replace('js_slider-unique-line', 'js_slider-from-ajax')));

            homePageBuilder();
        } finally {
            loading = false;
        }
    };

    const initializeScrollListener = () => {
        $(document).on('scroll', () => {
            loadNextSegment();
        });
    };

    const initializeLazyLoading = () => {
        const initialScrollTop = $(document).scrollTop();

        if (initialScrollTop === 0) {
            initializeScrollListener();
            loadNextSegment();
        } else {
            loadAllSegments();
        }
    };

    const loadAllSegments = async () => {
        while (page <= total) {
            await loadNextSegment();
        }
    };

    $(document).ready(() => {
        setTimeout(initializeLazyLoading, 100);
    });
};
